import { Component } from 'preact'
import styles from './style.styl'
import { Caption, Regular } from '../text'
import { withClass } from '../../utils'
import {
  Akqa,
  Microsoft,
  Google,
  Pentagram,
  Dropbox,
  Uber,
  Foster,
  Amazon,
  Saatchi
} from '../icons'
import ApplyButton from '../apply-button'
import zaha from '../../assets/images/logos/zaha.png'

const EXPERTS_I = [
  {
    name: 'dropbox',
    icon: Dropbox,
    className: styles.dropbox,
    href: ''
  },
  {
    name: 'zaha hadid architects',
    className: styles.zaha,
    href: '',
    imageSrc: zaha
  },
  {
    name: 'm<span class="alt">i</span>crosoft',
    icon: Microsoft,
    className: styles.microsoft,
    href: ''
  },
  {
    name: 'saatchi & saatchi',
    icon: Saatchi,
    className: styles.saatchi,
    href: ''
  },
  {
    name: 'amazon',
    icon: Amazon,
    className: styles.amazon,
    href: ''
  }
]

const EXPERTS_II = [ {
  name: 'uber',
  icon: Uber,
  className: styles.uber,
  href: ''
}, {
  name: 'google',
  icon: Google,
  className: styles.google,
  href: ''
}, {
  name: 'akqa',
  icon: Akqa,
  className: styles.akqa,
  href: ''
}, {
  name: 'pentagram',
  icon: Pentagram,
  className: styles.pentagram,
  href: ''
}, {
  name: 'foster + partners',
  icon: Foster,
  className: styles.foster,
  href: ''
} ]

const EXPERTS_MOBILE = [

  {
    name: 'zaha hadid architects',
    className: styles.zaha,
    href: '',
    imageSrc: zaha
  },
  {
    name: 'dropbox',
    icon: Dropbox,
    className: styles.dropbox,
    href: ''
  },
  {
    name: 'amazon',
    icon: Amazon,
    className: styles.amazon,
    href: ''
  },
  {
    name: 'm<span class="alt">i</span>crosoft',
    icon: Microsoft,
    className: styles.microsoft,
    href: ''
  },
  {
    name: 'saatchi & saatchi',
    icon: Saatchi,
    className: styles.saatchi,
    href: ''
  },
  {
    name: 'uber',
    icon: Uber,
    className: styles.uber,
    href: ''
  }, {
    name: 'google',
    icon: Google,
    className: styles.google,
    href: ''
  }, {
    name: 'akqa',
    icon: Akqa,
    className: styles.akqa,
    href: ''
  }, {
    name: 'pentagram',
    icon: Pentagram,
    className: styles.pentagram,
    href: ''
  }, {
    name: 'foster + partners',
    icon: Foster,
    className: styles.foster,
    href: ''
  } ]

const EXPERTS = [ ...EXPERTS_I, ...EXPERTS_II ].reduce((partitioned, expert, expertIndex) =>
  expertIndex % 2 === 0
    ? [ ...partitioned, [ expert ] ]
    : [
      ...partitioned.slice(0, partitioned.length - 1),
      [
        ...partitioned[partitioned.length - 1],
        expert
      ]
    ]
, [])

const Row = withClass(styles.row)('div')
const RowM = withClass(styles.rowM)('div')
const Circle = withClass(styles.circle)(Caption)

class Item extends Component {
  render () {
    const { name, className, icon: Icon, imageSrc } = this.props
    return (
      <div data-name={name} className={styles.item}>
        <Circle dangerouslySetInnerHTML={{ __html: name }} />
        {imageSrc ? <img src={imageSrc} className={className} alt={name} /> : <Icon className={className} />}
      </div>
    )
  }
}

class Experts extends Component {
  render () {
    return (
      <div className={styles.experts}>
        <ApplyButton />
        <Regular className={styles.caption}>
          Taught by the industry’s top CEOs, <br />
          CFOs, COOs, Investors and Business <br />
          Leaders from design-led companies.
        </Regular>

        <div className={styles.desktop}>
          <Row>
            {EXPERTS_I.map((expert, index) => (
              <Item key={`expert-I-${index}`} {...expert} />
            ))}
          </Row>
          <Row>
            {EXPERTS_II.map((expert, index) => (
              <Item key={`expert-II-${index}`} {...expert} />
            ))}
          </Row>
          {EXPERTS.map(([expert1, expert2], index) => (
            <RowM key={`expert-row-${index}`}>
              <Item {...expert1} />
              <Item {...expert2} />
            </RowM>
          ))}
        </div>

        <div className={styles.mobileExperts}>
          {EXPERTS_MOBILE.map((expert, index) => (
            <div className={styles.row}>
              <Item key={`mobile-expert-${index}`} {...expert} />
            </div>
          ))}
        </div>

      </div>
    )
  }
}

export default Experts



// WEBPACK FOOTER //
// ./components/experts/index.js